import {
  FIELD_MEMBERS,
  FIELD_SET_COMMON_PAY_FREQUENCY,
  FIELD_GROUP_BUTTONS,
  FIELD_MEMBER_SELECTED,
} from './constants.fields';
import { FormattedMessage } from 'react-intl';
import { getMemberKey } from 'pages/AffordaHousehold/utils';
import { WAGES_AND_INCOME_COMMON_FIELD_NAMES } from './constants.fields';

export const MESSAGE_IDS = {
  title: 'afforda.wagesAndIncome.details.unemployment.title',
  description: 'afforda.wagesAndIncome.details.unemployment.subtitle',
  addButton: 'afforda.wagesAndIncome.details.unemployment.add',
  addCaption: 'afforda.wagesAndIncome.details.unemployment.addDescription',
};

export const UNEMPLOYMENT_FIELD_NAMES = {
  [WAGES_AND_INCOME_COMMON_FIELD_NAMES.id]:
    WAGES_AND_INCOME_COMMON_FIELD_NAMES.id,
  [WAGES_AND_INCOME_COMMON_FIELD_NAMES.annualAmount]:
    WAGES_AND_INCOME_COMMON_FIELD_NAMES.annualAmount,
  [WAGES_AND_INCOME_COMMON_FIELD_NAMES.memberId]:
    WAGES_AND_INCOME_COMMON_FIELD_NAMES.memberId,
  [WAGES_AND_INCOME_COMMON_FIELD_NAMES.monthlyAmount]:
    WAGES_AND_INCOME_COMMON_FIELD_NAMES.monthlyAmount,
  [WAGES_AND_INCOME_COMMON_FIELD_NAMES.payFrequency]:
    WAGES_AND_INCOME_COMMON_FIELD_NAMES.payFrequency,
  [WAGES_AND_INCOME_COMMON_FIELD_NAMES.source]:
    WAGES_AND_INCOME_COMMON_FIELD_NAMES.source,
  [WAGES_AND_INCOME_COMMON_FIELD_NAMES.weeklyAmount]:
    WAGES_AND_INCOME_COMMON_FIELD_NAMES.weeklyAmount,
};

const getHasRecordSSI = (items, memberId) => {
  return items.find(
    (record) =>
      record.memberId === memberId && record.source === SOURCE_UNEMPLOYMENT,
  );
};

const getHasRecordSSDI = (items, memberId) => {
  return items.find(
    (record) =>
      record.memberId === memberId && record.source === SOURCE_DISABILITY,
  );
};
export const getIsAddDisabled = ({ members, items }) => {
  const membersAvailable =
    members?.filter((member) => {
      const memberKey = getMemberKey(member);
      const hasRecordSsi = getHasRecordSSI(items, memberKey);
      const hasRecordSsdi = getHasRecordSSDI(items, memberKey);
      return !(hasRecordSsi && hasRecordSsdi);
    }) ?? [];

  return membersAvailable.length > 0;
};

export const NEW_UNEMPLOYMENT = {
  memberId: '',
  payFrequency: '',
  weeklyAmount: '',
  monthlyAmount: '',
  annualAmount: '',
  source: '',

  //
  isOpen: true,
  totalIncome: 0,
};

export const getDefaultValues = (item) => {
  return {
    ...item,
    id: item.id,
    [UNEMPLOYMENT_FIELD_NAMES.source]: item.source ?? '',
    [UNEMPLOYMENT_FIELD_NAMES.payFrequency]: item.payFrequency ?? '',
    [UNEMPLOYMENT_FIELD_NAMES.weeklyAmount]: item.weeklyAmount ?? '',
    [UNEMPLOYMENT_FIELD_NAMES.monthlyAmount]: item.monthlyAmount ?? '',
    [UNEMPLOYMENT_FIELD_NAMES.annualAmount]: item.annualAmount ?? '',
  };
};

export const getFormProps = ({ members, items, memberId }) => {
  const disabledMembers =
    members
      ?.filter((member) => {
        const memberKey = getMemberKey(member);
        const hasRecordSsi = getHasRecordSSI(items, memberKey);
        const hasRecordSsdi = getHasRecordSSDI(items, memberKey);
        return hasRecordSsi && hasRecordSsdi;
      })
      ?.map(({ id }) => id) ?? [];

  const itemsExceptLast = items.slice(0, items.length - 1);

  const disabledCurrentSources = Object.values(
    UNEMPLOYMENT_SOURCE_OPTIONS,
  ).filter((option) => {
    return itemsExceptLast.find(
      (record) =>
        record?.memberId === memberId && record.source === option.value,
    );
  });

  return {
    disabledMembers,
    disabledCurrentSources,
  };
};

export const SOURCE_UNEMPLOYMENT = 'unemployment';
export const SOURCE_DISABILITY = 'disability';

export const UNEMPLOYMENT_SOURCE_OPTIONS = {
  SOURCE_UNEMPLOYMENT: {
    value: SOURCE_UNEMPLOYMENT,
    text: 'afforda.wagesAndIncome.details.unemployment.source.unemployment',
  },
  SOURCE_DISABILITY: {
    value: SOURCE_DISABILITY,
    text: 'afforda.wagesAndIncome.details.unemployment.source.disability',
  },
};

export const FIELDS = ({
  members,
  disabledMembers,
  disabledCurrentSources,
}) => {
  return [
    ...FIELD_MEMBERS({ members, disabledMembers }),
    {
      ...FIELD_GROUP_BUTTONS,
      ...FIELD_MEMBER_SELECTED,
      label: <FormattedMessage id="afforda.wagesAndIncome.details.source" />,
      name: UNEMPLOYMENT_FIELD_NAMES.source,
      direction: 'row',
      options: Object.values(UNEMPLOYMENT_SOURCE_OPTIONS)?.map((option) => ({
        value: option.value,
        label: <FormattedMessage id={option.text} />,
        disabled: disabledCurrentSources
          ?.map(({ value }) => value)
          .includes(option.value),
      })),
    },
    // Pay Frequency
    ...FIELD_SET_COMMON_PAY_FREQUENCY,
  ];
};
